<template>
  <div class="text-left" id="sideMenuDiv" style="padding:0px 10px 0 0; cursor:pointer">
    <div class="col-lg-12 panel side" id="jacket"> 
      <div @click.prevent="openMenu('jacket')" >
      <span class="fa fa-check" v-if="jacket_selected"></span> 
      <b>Jacket Style</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="row" style="padding:10px 0px 0px 0" v-if="jacket_div">
        <div class="col-sm-6 text-center" v-for="jacket in jacketDesign" :key="jacket.id" >
           <img :src="'https://www.customvarsityapparel.com.au/customize/img/'+jacket.src" alt="" class="img-responsive jacketDesign " :class="(curentJacket === jacket.name && jacket_selected === true) ? 'active':''" :id="jacket.id"  @click.prevent="chooseStyle(jacket.name,jacket.id)" style="padding:5px;border-radius:5px;width: 45vh">
        </div>
      </div>
      <p v-if="jacket_error" class="error"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{jacketErrorMessage}}</p> 
    </div>
    <div class="col-lg-12 panel side" id="body"> 
      <div @click.prevent="openMenu('body')">
      <span class="fa fa-check" v-if="body_selected"></span> 
      <b>Jacket Body</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" style="padding:10px 10px 0px 15px" v-if="body_div">
        <p>Choose Body Color</p>
        <div class="row">
          <span class="list-item-color body-list-color" v-for="color in colors" :class="(body_id === 'body_'+color.id) ? 'color_active': ''" :key="color.id" :id="'body_'+color.id" :style="color.style" @click.prevent="fillColor('body',color.id,color.dataColor)"></span>
        </div>
      </div>
    </div>
    <div class="col-lg-12 panel side" id="sleeve"> 
      <div @click.prevent="openMenu('sleeve')">
        <span class="fa fa-check" v-if="sleeve_selected"></span> 
        <b>Jacket Sleeves</b> 
        <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" style="padding:10px 10px 0px 15px" v-if="sleeve_div">
        <p>Choose Sleeve Color</p>
        <div class="row">
          <span class="list-item-color sleeve-list-color" v-for="color in colors" :id="'sleeve_'+color.id" :class="(sleeve_id === 'sleeve_'+color.id) ? 'color_active': ''" :key="color.id" :style="color.style" @click.prevent="fillColor('sleeve',color.id,color.dataColor)"></span>
        </div>
      </div>
    </div>
    <div class="col-lg-12 panel side" id="pocket"> 
      <div @click.prevent="openMenu('pocket')">
      <span class="fa fa-check" v-if="pocket_selected"></span> 
      <b>Jacket Pockets</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" style="padding:10px 10px 0px 15px" v-if="pocket_div">
        <p>Choose Pocket Color</p>
        <div class="row">
          <span class="list-item-color pocket-list-color" v-for="color in colors" :id="'pocket_'+color.id" :class="(pocket_id === 'pocket_'+color.id) ? 'color_active': ''" :key="color.id" :style="color.style" @click.prevent="fillColor('pocket',color.id,color.dataColor)"></span>
        </div>
      </div>
    </div>
    <div class="col-lg-12 panel side" id="button"> 
      <div @click.prevent="openMenu('button')">
      <span class="fa fa-check" v-if="button_selected"></span> 
      <b>Jacket Buttons</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" style="padding:10px 10px 0px 15px" v-if="button_div">
        <p>Choose Button Color</p>
        <div class="row">
          <span class="list-item-color button-list-color" v-for="color in colors" :id="'button_'+color.id" :class="(button_id === 'button_'+color.id) ? 'color_active': ''" :key="color.id" :style="color.style" @click.prevent="fillColor('button',color.id,color.dataColor)"></span>
        </div>
      </div>
    </div>
    <div class="col-lg-12 panel side" id="knit"> 
      <div @click.prevent="openMenu('knit')">
      <span class="fa fa-check"  v-if="knit_selected"></span> 
      <b>Knit Trim</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" style="padding:10px 5px 0px 10px" v-if="knit_div">
         <p class="trim_btn" @click.prevent="openTrim('solid')" :class="(solid_selected === true && knit_selected === true) ? 'active_trim':''"> 
           <img src="https://www.customvarsityapparel.com.au/customize/img/menu/1.png"> <span>Solid Color</span></p>
         <p class="trim_btn" @click.prevent="openTrim('single_stripe')" :class="(single_selected === true && knit_selected === true) ? 'active_trim':''">
           <img src="https://www.customvarsityapparel.com.au/customize/img/menu/2.png"> <span>Single Stripe</span></p>
         <p class="trim_btn" @click.prevent="openTrim('double_stripe')" :class="(double_selected === true && knit_selected === true) ? 'active_trim':''">
           <img src="https://www.customvarsityapparel.com.au/customize/img/menu/3.png"> <span>Two Stripes</span></p>
         <p class="trim_btn" @click.prevent="openTrim('feather_stripe')" :class="(feather_selected === true && knit_selected === true) ? 'active_trim':''">
           <img src="https://www.customvarsityapparel.com.au/customize/img/menu/4.png"> <span>Two Stripes with Feathering</span></p>
             
         <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="solid_div">
          <p><b>Base Color</b></p>
          <div class="row" style="padding-left:-5px">
            <span class="list-item-color solid-list-color" v-for="color in colors" :key="color.id" :id="'solid_'+color.id" :class="(solid_id === 'solid_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillColorknit('solid',color.id,color.dataColor)"></span>
          </div>
        </div> 
        <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="single_div">
          <p><b>Single Line Color</b></p>
          <div class="row" style="padding-left:-5px">
            <span class="list-item-color single_stripe-list-color" v-for="color in colors" :key="color.id" :id="'single_stripe_'+color.id" :class="(single_stripe_id === 'single_stripe_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillColorknit('single_stripe',color.id,color.dataColor)"></span>
          </div>
        </div> 
        <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="double_div">
          <p><b>Two Lines Color</b></p>
          <div class="row" style="padding-left:-5px">
            <span class="list-item-color double_stripe-list-color" v-for="color in colors" :key="color.id" :id="'double_stripe_'+color.id" :class="(double_stripe_id === 'double_stripe_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillColorknit('double_stripe',color.id,color.dataColor)"></span>
          </div>
        </div> 
        <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="feather_div">
          <p><b>Feather Color</b></p>
          <div class="row" style="padding-left:-5px">
            <span class="list-item-color feather_stripe-list-color" v-for="color in colors" :key="color.id" :id="'feather_stripe_'+color.id" :class="(feather_stripe_id === 'feather_stripe_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillColorknit('feather_stripe',color.id,color.dataColor)"></span>
          </div>
        </div> 
        
      </div>
    </div>

    <!-- leftchest Starts  -->
    <div class="col-lg-12 panel side" id="leftChest"> 
      <div @click.prevent="openMenu('leftChest')">
      <span class="fa fa-check" v-if="leftChest_selected"></span> 
      <b>Left Chest Personalization</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" id="leftChest" style="padding:10px 10px 0px 15px" v-if="leftChest_div">
        <div v-for="left in leftChest" :key="left.id" 
          :class="(leftChest_id === left.id) ? 'activeList' : 'customList'">
          <input type="radio" :id="left.id" :value="left.value" :name="left.name"
          @change="openCustomization(left.id,left.name)" 
          :checked="(leftChest_id === left.id)"
          >
          <label :for="left.id" 
          :class="(leftChest_id === left.id) ? 'activeLevel' : ''"
          >{{ left.lavel }}</label>
        </div>

        <div class="clearfix"></div>

        <!-- left chest letters  -->

        <div class="col-md-12" :class="(leftChest_id === 'leftChest_letters') ? 'activeDiv' : ''" 
          v-if="leftChest_id === 'leftChest_letters'">
          <div class="form-group">
              <input type="text" class="form-control" maxlength="3" @keyup="setText('leftChest',$event)" placeholder="ENTER 3 LETTERS" autocomplete="off" :value="leftChest_letters">
              <select class="form-control" @change.prevent="setFontFamily('leftChest',$event)">
                <option value="">Select Font Style</option>
                <option v-for="font in fonts" :key="font.id" :id="font.id" :value="font.value"
                :selected="leftChest_letters_fontfamily_id === 'leftChest_letters_fontfamily_'+font.id"
                >{{ font.name }}</option>
              </select>
              <select class="form-control" 
              @change="openCustizeColor('leftChest',$event)">
                <option value="">Select One or Two Color</option>
                <option :value="ctype.value" :id="ctype.id" v-for="ctype in colorType" :key="ctype.id"
                :selected="leftChest_letters_colors_id === 'leftChest_letters_colors_'+ctype.id"
                >
                  {{ ctype.name }}</option>
              </select>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="leftChest_basecolor_div">
            <p><b>Base Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color solid-list-color" v-for="color in colors" :key="color.id" :id="'leftChest_basecolor_'+color.id" :class="(leftChest_basecolor_id === 'leftChest_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('leftChest','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="leftChest_outlinecolor_div">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color single_stripe-list-color" v-for="color in colors" :key="color.id" :id="'leftChest_outlinecolor_'+color.id" :class="(leftChest_outlinecolor_id === 'leftChest_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('leftChest','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
        </div>
        <!-- left chest letters  Ends -->
        <!-- left chest Logos  -->
        <div class="col-md-12" :class="(leftChest_id === 'leftChest_logos') ? 'activeDiv' : ''"  
            v-if="leftChest_id === 'leftChest_logos'">
           <p><b>Select Logo</b></p>  
           <div class="form-group">
              <img src="https://www.customvarsityapparel.com.au/customize/img/your-logo-here.png" width="50" @click.prevent="setImage('leftChest',$event)">
           </div>
        </div>
        <!-- left chest Logos Ends  -->        
        <!-- left chest Years  -->
        <div class="col-md-12" :class="(leftChest_id === 'leftChest_years') ? 'activeDiv' : ''" 
            v-if="leftChest_id === 'leftChest_years'">
          <div class="form-group">
            <p><b>Select Years</b></p> 
            <select class="form-control" 
            @change="openYearColor('leftChest',$event)">
              <option value="">Select Years</option>
              <option v-for="(year, index) in yearList()" :id="index+1" :key="index+1" :value="year"
              :selected="leftChest_years_id === 'leftChest_years_'+parseInt(index+1)"
              >
                {{ year}} </option>
            </select>
          </div>
          <div class="row" style="margin-left:0;margin-right:0" v-if="leftChest_years_color_div">
            <div class="col-md-12" style="padding:10px 10px 0px 0px">
            <p><b>Select Base Color</b></p>
            <div class="row" style="margin-left:0;margin-right:0">
              <span class="list-item-color solid-list-color" 
              v-for="color in colors" :key="color.id" 
              :id="'leftChest_years_basecolor_'+color.id" 
              :class="(leftChest_years_basecolor_id === 'leftChest_years_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" 
              @click.prevent="fillYearColor('leftChest_years','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin-left:0; margin-right:0">
              <span class="list-item-color single_stripe-list-color" 
              v-for="color in colors" :key="color.id" 
              :id="'leftChest_years_outlinecolor_'+color.id" 
              :class="(leftChest_years_outlinecolor_id === 'leftChest_years_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" 
              @click.prevent="fillYearColor('leftChest_years','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          </div>
        </div>
      <!-- left chest years Ends  -->
      </div>
    </div>
    <!-- leftchest Ends  -->  
    <!-- rightChest Starts -->
    <div class="col-lg-12 panel side" id="rightChest"> 
      <div @click.prevent="openMenu('rightChest')">
      <span class="fa fa-check" v-if="rightChest_selected"></span> 
      <b>Right Chest Personalization</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" id="rightChest" style="padding:10px 10px 0px 15px" v-if="rightChest_div">
        <div v-for="right in rightChest" :key="right.id" 
          :class="(rightChest_id === right.id) ? 'activeList' : 'customList'">
          <input type="radio" :id="right.id" :value="right.value" :name="right.name"
          @change="openCustomization(right.id,right.name)" 
          :checked="(rightChest_id === right.id)"
          >
          <label :for="right.id" 
          :class="(rightChest_id === right.id) ? 'activeLevel' : ''"
          >{{ right.lavel }}</label>
        </div>

        <div class="clearfix"></div>

        <!-- Right chest Letters  -->
        <div class="col-md-12" :class="(rightChest_id === 'rightChest_letters') ? 'activeDiv' : ''" 
          v-if="rightChest_id === 'rightChest_letters'">
          <div class="form-group">
              <input type="text" class="form-control" maxlength="3" @keyup="setText('rightChest',$event)" placeholder="ENTER 3 LETTERS" autocomplete="off" :value="rightChest_letters">
              <select class="form-control" @change.prevent="setFontFamily('rightChest',$event)">
                <option value="">Select Font Style</option>
                <option v-for="font in fonts" :key="font.id" :id="font.id" :value="font.value"
                :selected="rightChest_letters_fontfamily_id === 'rightChest_letters_fontfamily_'+font.id"
                >{{ font.name }}</option>
              </select>
              <select class="form-control" 
              @change="openCustizeColor('rightChest',$event)">
                <option value="">Select One or Two Color</option>
                <option :value="ctype.value" :id="ctype.id" v-for="ctype in colorType" :key="ctype.id"
                :selected="rightChest_letters_colors_id === 'rightChest_letters_colors_'+ctype.id"
                >
                  {{ ctype.name }}</option>
              </select>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="rightChest_basecolor_div">
            <p><b>Base Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color solid-list-color" v-for="color in colors" :key="color.id" :id="'rightChest_basecolor_'+color.id" :class="(rightChest_basecolor_id === 'rightChest_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('rightChest','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="rightChest_outlinecolor_div">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color single_stripe-list-color" v-for="color in colors" :key="color.id" :id="'rightChest_outlinecolor_'+color.id" :class="(rightChest_outlinecolor_id === 'rightChest_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('rightChest','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
        </div>
        <!-- Right chest letters  Ends -->

        <!-- Right chest Name  -->
        <div class="col-md-12" :class="(rightChest_id === 'rightChest_name') ? 'activeDiv' : ''" 
          v-if="rightChest_id === 'rightChest_name'">
          <div class="form-group">
              <input type="text" class="form-control" maxlength="16" @keyup="setText('rightChest',$event)" placeholder="ENTER 16 LETTERS" autocomplete="off" :value="rightChest_name">
              <select class="form-control" @change.prevent="setFontFamily('rightChest',$event)">
                <option value="">Select Font Style</option>
                <option v-for="font in fonts" :key="font.id" :id="font.id" :value="font.value"
                :selected="rightChest_name_fontfamily_id === 'rightChest_name_fontfamily_'+font.id"
                >{{ font.name }}</option>
              </select>
              <div class="col-md-12" style="padding:10px 10px 0px 0px">
                <p><b>Base Color</b></p>
                <div class="row" style="margin:0px;">
                  <span class="list-item-color solid-list-color" v-for="color in colors" :key="color.id" :id="'rightChest_name_basecolor_'+color.id" :class="(rightChest_name_basecolor_id === 'rightChest_name_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('rightChest_name','basecolor',color.id,color.dataColor)"></span>
                </div>
              </div>
          </div> 
        </div>
        <!-- Right chest Name  Ends -->
        

        <!-- Right chest Logos  -->
        <div class="col-md-12" :class="(rightChest_id === 'rightChest_logos') ? 'activeDiv' : ''"  
            v-if="rightChest_id === 'rightChest_logos'">
           <p><b>Select Logo</b></p>  
           <div class="form-group">
              <img src="https://www.customvarsityapparel.com.au/customize/img/your-logo-here.png" width="50" @click.prevent="setImage('rightChest',$event)">
           </div>
        </div>
        <!-- Right chest Logos Ends  -->        
        <!-- Right chest Years  -->
        <div class="col-md-12" :class="(rightChest_id === 'rightChest_years') ? 'activeDiv' : ''" 
            v-if="rightChest_id === 'rightChest_years'">
          <div class="form-group">
            <p><b>Select Years</b></p> 
            <select class="form-control" 
            @change="openYearColor('rightChest',$event)">
              <option value="">Select Years</option>
              <option v-for="(year, index) in yearList()" :id="index+1" :key="index+1" :value="year"
              :selected="rightChest_years_id === 'rightChest_years_'+parseInt(index+1)"
              >
                {{ year}} </option>
            </select>
          </div>
          <div class="row" style="margin-left:0;margin-right:0" v-if="rightChest_years_color_div">
            <div class="col-md-12" style="padding:10px 10px 0px 0px">
            <p><b>Select Base Color</b></p>
            <div class="row" style="margin-left:0;margin-right:0">
              <span class="list-item-color solid-list-color" 
              v-for="color in colors" :key="color.id" 
              :id="'rightChest_years_basecolor_'+color.id" 
              :class="(rightChest_years_basecolor_id === 'rightChest_years_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" 
              @click.prevent="fillYearColor('rightChest_years','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin-left:0; margin-right:0">
              <span class="list-item-color single_stripe-list-color" 
              v-for="color in colors" :key="color.id" 
              :id="'rightChest_years_outlinecolor_'+color.id" 
              :class="(rightChest_years_outlinecolor_id === 'rightChest_years_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" 
              @click.prevent="fillYearColor('rightChest_years','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          </div>
        </div>
        <!-- Right chest years Ends  -->


      </div>
    </div>
    <!-- rightChest Ends -->


    



    <!-- rightSleeve Starts -->
    <div class="col-lg-12 panel side" id="rightSleeve"> 
      <div @click.prevent="openMenu('rightSleeve')">
      <span class="fa fa-check" v-if="rightSleeve_selected"></span> 
      <b>Right Sleeve Personalization</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" id="rightSleeve" style="padding:10px 10px 0px 15px" v-if="rightSleeve_div">
        <div v-for="right in rightSleeve" :key="right.id" 
          :class="(rightSleeve_id === right.id) ? 'activeList' : 'customList'">
          <input type="radio" :id="right.id" :value="right.value" :name="right.name"
          @change="openCustomization(right.id,right.name)" 
          :checked="(rightSleeve_id === right.id)"
          >
          <label :for="right.id" 
          :class="(rightSleeve_id === right.id) ? 'activeLevel' : ''"
          >{{ right.lavel }}</label>
        </div>

        <div class="clearfix"></div>

        <!-- Right Sleeve Letters  -->
        <div class="col-md-12" :class="(rightSleeve_id === 'rightSleeve_letters') ? 'activeDiv' : ''" 
          v-if="rightSleeve_id === 'rightSleeve_letters'">
          <div class="form-group">
              <input type="text" class="form-control" maxlength="3" @keyup="setText('rightSleeve',$event)" placeholder="ENTER 3 LETTERS" autocomplete="off" :value="rightSleeve_letters">
              <select class="form-control" @change.prevent="setFontFamily('rightSleeve',$event)">
                <option value="">Select Font Style</option>
                <option v-for="font in fonts" :key="font.id" :id="font.id" :value="font.value"
                :selected="rightSleeve_letters_fontfamily_id === 'rightSleeve_letters_fontfamily_'+font.id"
                >{{ font.name }}</option>
              </select>
              <select class="form-control" 
              @change="openCustizeColor('rightSleeve',$event)">
                <option value="">Select One or Two Color</option>
                <option :value="ctype.value" :id="ctype.id" v-for="ctype in colorType" :key="ctype.id"
                :selected="rightSleeve_letters_colors_id === 'rightSleeve_letters_colors_'+ctype.id"
                >
                  {{ ctype.name }}</option>
              </select>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="rightSleeve_basecolor_div">
            <p><b>Base Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color solid-list-color" v-for="color in colors" :key="color.id" :id="'rightSleeve_basecolor_'+color.id" :class="(rightSleeve_basecolor_id === 'rightSleeve_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('rightSleeve','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="rightSleeve_outlinecolor_div">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color single_stripe-list-color" v-for="color in colors" :key="color.id" :id="'rightSleeve_outlinecolor_'+color.id" :class="(rightSleeve_outlinecolor_id === 'rightSleeve_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('rightSleeve','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
        </div>
        <!-- left Sleeve letters  Ends -->
        <!-- left Sleeve Logos  -->
        <div class="col-md-12" :class="(rightSleeve_id === 'rightSleeve_logos') ? 'activeDiv' : ''"  
            v-if="rightSleeve_id === 'rightSleeve_logos'">
           <p><b>Select Logo</b></p>  
           <div class="form-group">
              <img src="https://www.customvarsityapparel.com.au/customize/src/assets/your-logo-here.png" width="50" @click.prevent="setImage('rightSleeve',$event)">
           </div>
        </div>
        <!-- left Sleeve Logos Ends  -->        
        <!-- left Sleeve Years  -->
        <div class="col-md-12" :class="(rightSleeve_id === 'rightSleeve_years') ? 'activeDiv' : ''" 
            v-if="rightSleeve_id === 'rightSleeve_years'">
          <div class="form-group">
            <p><b>Select Years</b></p> 
            <select class="form-control" 
            @change="openYearColor('rightSleeve',$event)">
              <option value="">Select Years</option>
              <option v-for="(year, index) in yearList()" :id="index+1" :key="index+1" :value="year"
              :selected="rightSleeve_years_id === 'rightSleeve_years_'+parseInt(index+1)"
              >
                {{ year}} </option>
            </select>
          </div>
          <div class="row" style="margin-left:0;margin-right:0" v-if="rightSleeve_years_color_div">
            <div class="col-md-12" style="padding:10px 10px 0px 0px">
            <p><b>Select Base Color</b></p>
            <div class="row" style="margin-left:0;margin-right:0">
              <span class="list-item-color solid-list-color" 
              v-for="color in colors" :key="color.id" 
              :id="'rightSleeve_years_basecolor_'+color.id" 
              :class="(rightSleeve_years_basecolor_id === 'rightSleeve_years_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" 
              @click.prevent="fillYearColor('rightSleeve_years','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin-left:0; margin-right:0">
              <span class="list-item-color single_stripe-list-color" 
              v-for="color in colors" :key="color.id" 
              :id="'rightSleeve_years_outlinecolor_'+color.id" 
              :class="(rightSleeve_years_outlinecolor_id === 'rightSleeve_years_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" 
              @click.prevent="fillYearColor('rightSleeve_years','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          </div>
        </div>
        <!-- left Sleeve years Ends  -->
      </div>
    </div>
    <!-- rightSleeve Ends -->


    <!-- leftSleeve Starts -->
    <div class="col-lg-12 panel side" id="leftSleeve"> 
      <div @click.prevent="openMenu('leftSleeve')">
      <span class="fa fa-check" v-if="leftSleeve_selected"></span> 
      <b>Left Sleeve Personalization</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" id="leftSleeve" style="padding:10px 10px 0px 15px" v-if="leftSleeve_div">
        <div v-for="right in leftSleeve" :key="right.id" 
          :class="(leftSleeve_id === right.id) ? 'activeList' : 'customList'">
          <input type="radio" :id="right.id" :value="right.value" :name="right.name"
          @change="openCustomization(right.id,right.name)" 
          :checked="(leftSleeve_id === right.id)"
          >
          <label :for="right.id" 
          :class="(leftSleeve_id === right.id) ? 'activeLevel' : ''"
          >{{ right.lavel }}</label>
        </div>

        <div class="clearfix"></div>

        <!-- Right Sleeve Letters  -->
        <div class="col-md-12" :class="(leftSleeve_id === 'leftSleeve_letters') ? 'activeDiv' : ''" 
          v-if="leftSleeve_id === 'leftSleeve_letters'">
          <div class="form-group">
              <input type="text" class="form-control" maxlength="3" @keyup="setText('leftSleeve',$event)" placeholder="ENTER 3 LETTERS" autocomplete="off" :value="leftSleeve_letters">
              <select class="form-control" @change.prevent="setFontFamily('leftSleeve',$event)">
                <option value="">Select Font Style</option>
                <option v-for="font in fonts" :key="font.id" :id="font.id" :value="font.value"
                :selected="leftSleeve_letters_fontfamily_id === 'leftSleeve_letters_fontfamily_'+font.id"
                >{{ font.name }}</option>
              </select>
              <select class="form-control" 
              @change="openCustizeColor('leftSleeve',$event)">
                <option value="">Select One or Two Color</option>
                <option :value="ctype.value" :id="ctype.id" v-for="ctype in colorType" :key="ctype.id"
                :selected="leftSleeve_letters_colors_id === 'leftSleeve_letters_colors_'+ctype.id"
                >
                  {{ ctype.name }}</option>
              </select>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="leftSleeve_basecolor_div">
            <p><b>Base Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color solid-list-color" v-for="color in colors" :key="color.id" :id="'leftSleeve_basecolor_'+color.id" :class="(leftSleeve_basecolor_id === 'leftSleeve_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('leftSleeve','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="leftSleeve_outlinecolor_div">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color single_stripe-list-color" v-for="color in colors" :key="color.id" :id="'leftSleeve_outlinecolor_'+color.id" :class="(leftSleeve_outlinecolor_id === 'leftSleeve_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('leftSleeve','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
        </div>
        <!-- left Sleeve letters  Ends -->
        <!-- left Sleeve Logos  -->
        <div class="col-md-12" :class="(leftSleeve_id === 'leftSleeve_logos') ? 'activeDiv' : ''"  
            v-if="leftSleeve_id === 'leftSleeve_logos'">
            <p><b>Select Logo</b></p>  
            <div class="form-group">
              <img src="https://www.customvarsityapparel.com.au/customize/img/your-logo-here.png" width="50" @click.prevent="setImage('leftSleeve',$event)">
            </div>
        </div>
        <!-- left Sleeve Logos Ends  -->        
        <!-- left Sleeve Years  -->
        <div class="col-md-12" :class="(leftSleeve_id === 'leftSleeve_years') ? 'activeDiv' : ''" 
            v-if="leftSleeve_id === 'leftSleeve_years'">
          <div class="form-group">
            <p><b>Select Years</b></p> 
            <select class="form-control" 
            @change="openYearColor('leftSleeve',$event)">
              <option value="">Select Years</option>
              <option v-for="(year, index) in yearList()" :id="index+1" :key="index+1" :value="year"
              :selected="leftSleeve_years_id === 'leftSleeve_years_'+parseInt(index+1)"
              >
                {{ year}} </option>
            </select>
          </div>
          <div class="row" style="margin-left:0;margin-right:0" v-if="leftSleeve_years_color_div">
            <div class="col-md-12" style="padding:10px 10px 0px 0px">
            <p><b>Select Base Color</b></p>
            <div class="row" style="margin-left:0;margin-right:0">
              <span class="list-item-color solid-list-color" 
              v-for="color in colors" :key="color.id" 
              :id="'leftSleeve_years_basecolor_'+color.id" 
              :class="(leftSleeve_years_basecolor_id === 'leftSleeve_years_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" 
              @click.prevent="fillYearColor('leftSleeve_years','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin-left:0; margin-right:0">
              <span class="list-item-color single_stripe-list-color" 
              v-for="color in colors" :key="color.id" 
              :id="'leftSleeve_years_outlinecolor_'+color.id" 
              :class="(leftSleeve_years_outlinecolor_id === 'leftSleeve_years_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" 
              @click.prevent="fillYearColor('leftSleeve_years','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          </div>
        </div>
        <!-- left Sleeve years Ends  -->
      </div>
    </div>
    <!-- leftSleeve Ends -->

    <!-- backCustomization Starts  -->

    <div class="col-lg-12 panel side" id="back"> 
      <div @click.prevent="openMenu('back')">
      <span class="fa fa-check" v-if="backShoulder_id"></span> 
      <b>Back Personalization</b> 
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" style="padding:10px 10px 0px 15px" v-if="back_div">
        <div v-for="bmenu in back" :key="bmenu.id" 
          :class="(backShoulder_id === bmenu.id) ? 'activeList' : 'customList'">
          <input type="radio" :id="bmenu.id" :value="bmenu.value" :name="bmenu.name"
          @change="openCustomization(bmenu.id,bmenu.name)" 
          :checked="(backShoulder_id === bmenu.id)"
          >
          <label :for="bmenu.id" 
          :class="(backShoulder_id === bmenu.id) ? 'activeLevel' : ''"
          >{{ bmenu.lavel }}</label>
        </div>

        <div class="clearfix"></div>

        <!-- Back Shoulder Letters Starts  -->
        <div class="col-md-12" :class="(backShoulder_id === 'backShoulder_letters') ? 'activeDiv' : ''" 
          v-if="backShoulder_id === 'backShoulder_letters'">
          <div class="form-group">
              <input type="text" class="form-control" maxlength="12" @keyup="setText('backShoulder',$event)" placeholder="ENTER 12 LETTERS" autocomplete="off" :value="backShoulder_letters">
              <select class="form-control" @change.prevent="setFontFamily('backShoulder',$event)">
                <option value="">Select Font Style</option>
                <option v-for="font in fonts" :key="font.id" :id="font.id" :value="font.value"
                :selected="backShoulder_letters_fontfamily_id === 'backShoulder_letters_fontfamily_'+font.id"
                >{{ font.name }}</option>
              </select>
              <select class="form-control" 
              @change="openCustizeColor('backShoulder',$event)">
                <option value="">Select One or Two Color</option>
                <option :value="ctype.value" :id="ctype.id" v-for="ctype in colorType" :key="ctype.id"
                :selected="backShoulder_letters_colors_id === 'backShoulder_letters_colors_'+ctype.id"
                >
                  {{ ctype.name }}</option>
              </select>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="backShoulder_letters_basecolor_div">
            <p><b>Base Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color solid-list-color" v-for="color in colors" :key="color.id" :id="'backShoulder_letters_basecolor_'+color.id" :class="(backShoulder_letters_basecolor_id === 'backShoulder_letters_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('backShoulder_letters','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="backShoulder_letters_outlinecolor_div">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color single_stripe-list-color" v-for="color in colors" :key="color.id" :id="'backShoulder_letters_outlinecolor_'+color.id" :class="(backShoulder_letters_outlinecolor_id === 'backShoulder_letters_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('backShoulder_letters','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
        </div>
        <!-- Back Shoulder letters Ends -->

        <!-- left Sleeve Logos  -->
        <div class="col-md-12" :class="(backShoulder_id === 'backShoulder_logos') ? 'activeDiv' : ''"  
            v-if="backShoulder_id === 'backShoulder_logos'">
            <p><b>Select Logo</b></p>  
            <div class="form-group">
              <img src="https://www.customvarsityapparel.com.au/customize/img/your-logo-here.png" width="50" @click.prevent="setImage('backShoulder',$event)">
            </div>
        </div>
        <!-- left Sleeve Logos Ends  --> 

        <!-- Back Waist Letters  -->
        <div class="col-md-12" :class="(backShoulder_id === 'backShoulderWaist_letters') ? 'activeDiv' : ''" 
          v-if="backShoulder_id === 'backShoulderWaist_letters'">
          <div class="form-group">
              <input type="text" class="form-control" maxlength="10" @keyup="setText('backShoulderWaist',$event)" placeholder="ENTER 10 LETTERS" autocomplete="off" :value="backShoulderWaist_letters">
              <select class="form-control" @change.prevent="setFontFamily('backShoulderWaist',$event)">
                <option value="">Select Font Style</option>
                <option v-for="font in fonts" :key="font.id" :id="font.id" :value="font.value"
                :selected="backShoulderWaist_letters_fontfamily_id === 'backShoulderWaist_letters_fontfamily_'+font.id"
                >{{ font.name }}</option>
              </select>
              <select class="form-control" 
              @change="openCustizeColor('backShoulderWaist',$event)">
                <option value="">Select One or Two Color</option>
                <option :value="ctype.value" :id="ctype.id" v-for="ctype in colorType" :key="ctype.id"
                :selected="backShoulderWaist_letters_colors_id === 'backShoulderWaist_letters_colors_'+ctype.id"
                >
                  {{ ctype.name }}</option>
              </select>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="backShoulderWaist_letters_basecolor_div">
            <p><b>Base Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color solid-list-color" v-for="color in colors" :key="color.id" :id="'backShoulderWaist_letters_basecolor_'+color.id" :class="(backShoulderWaist_letters_basecolor_id === 'backShoulderWaist_letters_basecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('backShoulderWaist_letters','basecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
          <div class="col-md-12" style="padding:10px 10px 0px 0px" v-if="backShoulderWaist_letters_outlinecolor_div">
            <p><b>Outline Color</b></p>
            <div class="row" style="margin:0px;">
              <span class="list-item-color single_stripe-list-color" v-for="color in colors" :key="color.id" :id="'backShoulderWaist_letters_outlinecolor_'+color.id" :class="(backShoulderWaist_letters_outlinecolor_id === 'backShoulderWaist_letters_outlinecolor_'+color.id) ? 'color_active': ''" :style="color.style" @click.prevent="fillCustomizeColor('backShoulderWaist_letters','outlinecolor',color.id,color.dataColor)"></span>
            </div>
          </div> 
        </div>
        <!-- Back Waist Letters  Ends -->
      </div>
    </div>
    <!-- backCustomization Ends  -->


    <!-- Place Order Starts  -->
    <div class="col-lg-12 panel side" id="place"> 
      <div @click.prevent="openMenu('place')">
      <span class="fa fa-check" v-if="place_id"></span> 
      <b>Send Enquiry</b>
      <span class="fa fa-arrow-right pull-right"></span>
      </div>
      <div class="col-md-12" style="padding:10px 0px 0px 0px" v-if="place_div">
        <!-- places Starts -->
        <div class="col-md-12" style="padding:10px 0px 0px 0px">
          <div class="form-group">
             <input ref="neme" type="text" class="form-control" v-model="order.name"
             id="name"
              @keyup="checkFieldTypeName($event)"
              placeholder="Name" autocomplete="nope">

             <p v-if="order.name_error">{{order.name_error}}</p>    

             <input type="text" ref="email" class="form-control" v-model="order.email" 
             @blur="isEmailValid()"
             id="email"
             placeholder="Email" autocomplete="nope"> 
              <p v-if="order.email_error">{{order.email_error}}</p>

             <input type="text" ref="mobile" class="form-control" v-model="order.mobile" 
             id="mobile"
             @keyup="checkFieldTypeMobile($event)"
             placeholder="Mobile" autocomplete="nope">

             <p v-if="order.mobile_error">{{order.mobile_error}}</p>

             <textarea class="form-control" style="overflow:auto;resize:none; height:100px" placeholder="Additional Details e.g., Quantity, Material Preference, Delivery Date etc" v-model="order.message"></textarea>
             <hr style="margin-top:10px; margin-bottom:5px">
             <button type="button" class="btn btn-success btn-block" style="border-radius:0" @click.prevent="addOrder()"> <i class="fas fa-envelope"></i>   Send Enquiry </button>     
          </div> 
        </div>
        <!-- place Ends -->
      </div>
    </div>
    <!-- Place Order Ends -->
    
    <!-- <button class="btn btn-success btn-block" @click.prevent="saveAsPng()">Save As PNG </button>   -->

    
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {

    name: 'JacketSideMenu',
    data() {
      return {
        order: {
          name: '',
          email: '',
          mobile: '',
          message: '',
          name_error: null,
          email_error: null,
          mobile_error: null,
          reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        }
      }
    },
    created() {
      this.$store.watch( getters => getters.jacket_error);
      this.$store.watch( getters => getters.jacketErrorMessage);
      this.$store.watch( getters => getters.jacketDesign);
      this.$store.watch( getters => getters.jacketSelectd);
      this.$store.watch( getters => getters.curentJacket);
      this.$store.watch( getters => getters.jacket_div);
      this.$store.watch( getters => getters.jacket_selected);
      this.$store.watch( getters => getters.styles);
      this.$store.watch( getters => getters.sizes);
      this.$store.watch( getters => getters.body_div);
      this.$store.watch( getters => getters.body_selected);
      this.$store.watch( getters => getters.body_id);

      this.$store.watch( getters => getters.sleeve_div);
      this.$store.watch( getters => getters.sleeve_selected);
      this.$store.watch( getters => getters.sleeve_id);

      this.$store.watch( getters => getters.pocket_div);
      this.$store.watch( getters => getters.pocket_selected);
      this.$store.watch( getters => getters.pocket_id);
      
      this.$store.watch( getters => getters.button_div);
      this.$store.watch( getters => getters.button_selected);
      this.$store.watch( getters => getters.button_id);

      this.$store.watch( getters => getters.knit_div);
      this.$store.watch( getters => getters.knit_selected);
      this.$store.watch( getters => getters.solid_div);
      this.$store.watch( getters => getters.solid_selected);
      this.$store.watch( getters => getters.solid_id);
      this.$store.watch( getters => getters.single_div);
      this.$store.watch( getters => getters.single_selected);
      this.$store.watch( getters => getters.single_stripe_id);
      this.$store.watch( getters => getters.double_div);
      this.$store.watch( getters => getters.double_selected);
      this.$store.watch( getters => getters.double_stripe_id);

      this.$store.watch( getters => getters.feather_div);
      this.$store.watch( getters => getters.feather_selected);
      this.$store.watch( getters => getters.feather_stripe_id);

      this.$store.watch( getters => getters.fonts);
      this.$store.watch( getters => getters.colorType);

      this.$store.watch( getters => getters.leftChest_div);
      this.$store.watch( getters => getters.leftChest_selected);
      this.$store.watch( getters => getters.leftChest_id);
      this.$store.watch( getters => getters.leftChest);
      this.$store.watch( getters => getters.leftChest_letters);
      this.$store.watch( getters => getters.leftChest_letters_fontfamily);
      this.$store.watch( getters => getters.leftChest_letters_fontfamily_id);

      this.$store.watch( getters => getters.leftChest_basecolor_div);
      this.$store.watch( getters => getters.leftChest_letters_colors_id);
      this.$store.watch( getters => getters.leftChest_outlinecolor_div);
      this.$store.watch( getters => getters.leftChest_basecolor_id);
      this.$store.watch( getters => getters.leftChest_outlinecolor_id);
      this.$store.watch( getters => getters.leftChest_logos);
      this.$store.watch( getters => getters.leftChest_years);
      this.$store.watch( getters => getters.leftChest_years_id);
      this.$store.watch( getters => getters.leftChest_years_color_div);
      this.$store.watch( getters => getters.leftChest_years_basecolor_id);
      this.$store.watch( getters => getters.leftChest_years_basecolor);
      this.$store.watch( getters => getters.leftChest_years_outlinecolor);
      this.$store.watch( getters => getters.leftChest_years_outlinecolor_id);

      this.$store.watch( getters => getters.rightChest_div);
      this.$store.watch( getters => getters.rightChest_selected);
      this.$store.watch( getters => getters.rightChest_id);
      this.$store.watch( getters => getters.rightChest);
      this.$store.watch( getters => getters.rightChest_letters);
      this.$store.watch( getters => getters.rightChest_letters_fontfamily);
      this.$store.watch( getters => getters.rightChest_letters_fontfamily_id);
      this.$store.watch( getters => getters.rightChest_name);
      this.$store.watch( getters => getters.rightChest_name_fontfamily_id);
      this.$store.watch( getters => getters.rightChest_name_basecolor_id);
      
      this.$store.watch( getters => getters.rightChest_basecolor_div);
      this.$store.watch( getters => getters.rightChest_letters_colors_id);
      this.$store.watch( getters => getters.rightChest_outlinecolor_div);
      this.$store.watch( getters => getters.rightChest_basecolor_id);
      this.$store.watch( getters => getters.rightChest_outlinecolor_id);
      this.$store.watch( getters => getters.rightChest_logos);
      this.$store.watch( getters => getters.rightChest_years);
      this.$store.watch( getters => getters.rightChest_years_id);
      this.$store.watch( getters => getters.rightChest_years_color_div);
      this.$store.watch( getters => getters.rightChest_years_basecolor_id);
      this.$store.watch( getters => getters.rightChest_years_basecolor);
      this.$store.watch( getters => getters.rightChest_years_outlinecolor);
      this.$store.watch( getters => getters.rightChest_years_outlinecolor_id);

      this.$store.watch( getters => getters.rightSleeve_div);
      this.$store.watch( getters => getters.rightSleeve_selected);
      this.$store.watch( getters => getters.rightSleeve_id);
      this.$store.watch( getters => getters.rightSleeve);
      this.$store.watch( getters => getters.rightSleeve_letters);
      this.$store.watch( getters => getters.rightSleeve_letters_fontfamily);
      this.$store.watch( getters => getters.rightSleeve_letters_fontfamily_id);
      this.$store.watch( getters => getters.rightSleeve_basecolor_div);
      this.$store.watch( getters => getters.rightSleeve_letters_colors_id);
      this.$store.watch( getters => getters.rightSleeve_outlinecolor_div);
      this.$store.watch( getters => getters.rightSleeve_basecolor_id);
      this.$store.watch( getters => getters.rightSleeve_outlinecolor_id);
      this.$store.watch( getters => getters.rightSleeve_logos);
      this.$store.watch( getters => getters.rightSleeve_years);
      this.$store.watch( getters => getters.rightSleeve_years_id);
      this.$store.watch( getters => getters.rightSleeve_years_color_div);
      this.$store.watch( getters => getters.rightSleeve_years_basecolor_id);
      this.$store.watch( getters => getters.rightSleeve_years_basecolor);
      this.$store.watch( getters => getters.rightSleeve_years_outlinecolor);
      this.$store.watch( getters => getters.rightSleeve_years_outlinecolor_id);
      
      this.$store.watch( getters => getters.leftSleeve_div);
      this.$store.watch( getters => getters.leftSleeve_selected);
      this.$store.watch( getters => getters.leftSleeve_id);
      this.$store.watch( getters => getters.leftSleeve);
      this.$store.watch( getters => getters.leftSleeve_letters);
      this.$store.watch( getters => getters.leftSleeve_letters_fontfamily);
      this.$store.watch( getters => getters.leftSleeve_letters_fontfamily_id);
      this.$store.watch( getters => getters.leftSleeve_basecolor_div);
      this.$store.watch( getters => getters.leftSleeve_letters_colors_id);
      this.$store.watch( getters => getters.leftSleeve_outlinecolor_div);
      this.$store.watch( getters => getters.leftSleeve_basecolor_id);
      this.$store.watch( getters => getters.leftSleeve_outlinecolor_id);
      this.$store.watch( getters => getters.leftSleeve_logos);
      this.$store.watch( getters => getters.leftSleeve_years);
      this.$store.watch( getters => getters.leftSleeve_years_id);
      this.$store.watch( getters => getters.leftSleeve_years_color_div);
      this.$store.watch( getters => getters.leftSleeve_years_basecolor_id);
      this.$store.watch( getters => getters.leftSleeve_years_basecolor);
      this.$store.watch( getters => getters.leftSleeve_years_outlinecolor);
      this.$store.watch( getters => getters.leftSleeve_years_outlinecolor_id);

      this.$store.watch( getters => getters.back_div);
      this.$store.watch( getters => getters.back_selected);
      this.$store.watch( getters => getters.backShoulder_id);
      this.$store.watch( getters => getters.backShoulder_letters);
      this.$store.watch( getters => getters.backShoulder_letters_fontfamily);
      this.$store.watch( getters => getters.backShoulder_letters_fontfamily_id);
      this.$store.watch( getters => getters.backShoulder_letters_colors_id);
      this.$store.watch( getters => getters.backShoulder_letters_basecolor_div);
      this.$store.watch( getters => getters.backShoulder_letters_basecolor);
      this.$store.watch( getters => getters.backShoulder_letters_basecolor_id);
      this.$store.watch( getters => getters.backShoulder_letters_outlinecolor_div);
      this.$store.watch( getters => getters.backShoulder_letters_outlinecolor);
      this.$store.watch( getters => getters.backShoulder_letters_outlinecolor_id);
      this.$store.watch( getters => getters.backShoulder_logos);
      this.$store.watch( getters => getters.backShoulderWaist_letters);
      this.$store.watch( getters => getters.backShoulderWaist_letters_fontfamily);
      this.$store.watch( getters => getters.backShoulderWaist_letters_fontfamily_id);
      this.$store.watch( getters => getters.backShoulderWaist_letters_colors_id);
      this.$store.watch( getters => getters.backShoulderWaist_letters_basecolor_div);
      this.$store.watch( getters => getters.backShoulderWaist_letters_basecolor);
      this.$store.watch( getters => getters.backShoulderWaist_letters_basecolor_id);
      this.$store.watch( getters => getters.backShoulderWaist_letters_outlinecolor_div);
      this.$store.watch( getters => getters.backShoulderWaist_letters_outlinecolor);
      this.$store.watch( getters => getters.backShoulderWaist_letters_outlinecolor_id);

      this.$store.watch( getters => getters.user_height_id);
      this.$store.watch( getters => getters.user_weight_id);
      this.$store.watch( getters => getters.user_size_id);
      this.$store.watch( getters => getters.place_div);
      this.$store.watch( getters => getters.place_id);
      this.$store.watch( getters => getters.jacketDetails)


      
    },
    mounted() {
      this.getmenuList(),
      this.yearList(),
      this.getHeights(),
      this.getWeight()
    },
    computed: {
      ...mapGetters({
        curentJacket: 'curentJacket',
        jacket_error: 'jacket_error',
        jacketErrorMessage: 'jacketErrorMessage',
        jacketDesign: 'jacketDesign',
        jacketSelectd: 'jacketSelectd',
        styles: 'styles',
        sides: 'sides',
        colors: 'colors',
        colorType: 'colorType',
        fonts: 'fonts',

        jacket_div: 'jacket_div',
        jacket_selected: 'jacket_selected',
        
        body_div: 'body_div',
        body_selected: 'body_selected',
        body_id: 'body_id',
        
        sleeve_div: 'sleeve_div',
        sleeve_selected: 'sleeve_selected',
        sleeve_id: 'sleeve_id',
        
        pocket_div: 'pocket_div',
        pocket_selected: 'pocket_selected',
        pocket_id: 'pocket_id',

        button_div: 'button_div',
        button_selected: 'button_selected',
        button_id: 'button_id',


        knit_div: 'knit_div',
        knit_selected: 'knit_selected',
        solid_div: 'solid_div',
        solid_selected: 'solid_selected',
        solid_id: 'solid_id',
        single_div: 'single_div',
        single_selected: 'single_selected',
        single_stripe_id: 'single_stripe_id',
        double_div: 'double_div',
        double_selected: 'double_selected',
        double_stripe_id: 'double_stripe_id',

        feather_div: 'feather_div',
        feather_selected: 'feather_selected',
        feather_stripe_id: 'feather_stripe_id',

        leftChest_div: 'leftChest_div',
        leftChest_selected: 'leftChest_selected',
        leftChest_id: 'leftChest_id',
        leftChest: 'leftChest', 
        leftChest_letters: 'leftChest_letters',
        leftChest_letters_fontfamily: 'leftChest_letters_fontfamily',
        leftChest_letters_fontfamily_id: 'leftChest_letters_fontfamily_id',
        leftChest_letters_colors_id: 'leftChest_letters_colors_id',
        leftChest_basecolor_div: 'leftChest_basecolor_div',
        leftChest_outlinecolor_div: 'leftChest_outlinecolor_div',
        leftChest_basecolor_id: 'leftChest_basecolor_id',
        leftChest_outlinecolor_id: 'leftChest_outlinecolor_id',
        leftChest_logos: 'leftChest_logos',
        leftChest_years: 'leftChest_years',
        leftChest_years_id: 'leftChest_years_id',
        leftChest_years_color_div: 'leftChest_years_color_div',
        leftChest_years_basecolor_id: 'leftChest_years_basecolor_id',
        leftChest_years_basecolor: 'leftChest_years_basecolor',
        leftChest_years_outlinecolor: 'leftChest_years_outlinecolor',
        leftChest_years_outlinecolor_id: 'leftChest_years_outlinecolor_id',

        rightChest_div: 'rightChest_div',
        rightChest_selected: 'rightChest_selected',
        rightChest_id: 'rightChest_id',
        rightChest: 'rightChest',
        rightChest_letters: 'rightChest_letters',
        rightChest_letters_fontfamily: 'rightChest_letters_fontfamily',
        rightChest_letters_fontfamily_id: 'rightChest_letters_fontfamily_id',

        rightChest_name: 'rightChest_name',
        rightChest_name_fontfamily_id: 'rightChest_name_fontfamily_id',
        rightChest_name_basecolor_id: 'rightChest_name_basecolor_id',
        
        rightChest_letters_colors_id: 'rightChest_letters_colors_id',
        rightChest_basecolor_div: 'rightChest_basecolor_div',
        rightChest_outlinecolor_div: 'rightChest_outlinecolor_div',
        rightChest_basecolor_id: 'rightChest_basecolor_id',
        rightChest_outlinecolor_id: 'rightChest_outlinecolor_id',
        rightChest_logos: 'rightChest_logos',
        rightChest_years: 'rightChest_years',
        rightChest_years_id: 'rightChest_years_id',
        rightChest_years_color_div: 'rightChest_years_color_div',
        rightChest_years_basecolor_id: 'rightChest_years_basecolor_id',
        rightChest_years_basecolor: 'rightChest_years_basecolor',
        rightChest_years_outlinecolor: 'rightChest_years_outlinecolor',
        rightChest_years_outlinecolor_id: 'rightChest_years_outlinecolor_id',

        rightSleeve_div: 'rightSleeve_div',
        rightSleeve_selected: 'rightSleeve_selected',
        rightSleeve_id: 'rightSleeve_id',
        rightSleeve: 'rightSleeve',
        rightSleeve_letters: 'rightSleeve_letters',
        rightSleeve_letters_fontfamily: 'rightSleeve_letters_fontfamily',
        rightSleeve_letters_fontfamily_id: 'rightSleeve_letters_fontfamily_id',
        rightSleeve_letters_colors_id: 'rightSleeve_letters_colors_id',
        rightSleeve_basecolor_div: 'rightSleeve_basecolor_div',
        rightSleeve_outlinecolor_div: 'rightSleeve_outlinecolor_div',
        rightSleeve_basecolor_id: 'rightSleeve_basecolor_id',
        rightSleeve_outlinecolor_id: 'rightSleeve_outlinecolor_id',
        rightSleeve_logos: 'rightSleeve_logos',
        rightSleeve_years: 'rightSleeve_years',
        rightSleeve_years_id: 'rightSleeve_years_id',
        rightSleeve_years_color_div: 'rightSleeve_years_color_div',
        rightSleeve_years_basecolor_id: 'rightSleeve_years_basecolor_id',
        rightSleeve_years_basecolor: 'rightSleeve_years_basecolor',
        rightSleeve_years_outlinecolor: 'rightSleeve_years_outlinecolor',
        rightSleeve_years_outlinecolor_id: 'rightSleeve_years_outlinecolor_id',

        leftSleeve_div: 'leftSleeve_div',
        leftSleeve_selected: 'leftSleeve_selected',
        leftSleeve_id: 'leftSleeve_id',
        leftSleeve: 'leftSleeve',
        leftSleeve_letters: 'leftSleeve_letters',
        leftSleeve_letters_fontfamily: 'leftSleeve_letters_fontfamily',
        leftSleeve_letters_fontfamily_id: 'leftSleeve_letters_fontfamily_id',
        leftSleeve_letters_colors_id: 'leftSleeve_letters_colors_id',
        leftSleeve_basecolor_div: 'leftSleeve_basecolor_div',
        leftSleeve_outlinecolor_div: 'leftSleeve_outlinecolor_div',
        leftSleeve_basecolor_id: 'leftSleeve_basecolor_id',
        leftSleeve_outlinecolor_id: 'leftSleeve_outlinecolor_id',
        leftSleeve_logos: 'leftSleeve_logos',
        leftSleeve_years: 'leftSleeve_years',
        leftSleeve_years_id: 'leftSleeve_years_id',
        leftSleeve_years_color_div: 'leftSleeve_years_color_div',
        leftSleeve_years_basecolor_id: 'leftSleeve_years_basecolor_id',
        leftSleeve_years_basecolor: 'leftSleeve_years_basecolor',
        leftSleeve_years_outlinecolor: 'leftSleeve_years_outlinecolor',
        leftSleeve_years_outlinecolor_id: 'leftSleeve_years_outlinecolor_id',

        back: 'back',
        back_div: 'back_div',
        back_selected: 'back_selected',
        backShoulder_id: 'backShoulder_id',
        backShoulder_letters:'backShoulder_letters',
        backShoulder_letters_fontfamily:'backShoulder_letters_fontfamily',
        backShoulder_letters_fontfamily_id:'backShoulder_letters_fontfamily_id',
        backShoulder_letters_colors_id:'backShoulder_letters_colors_id',
        backShoulder_letters_basecolor_div:'backShoulder_letters_basecolor_div',
        backShoulder_letters_basecolor:'backShoulder_letters_basecolor',
        backShoulder_letters_basecolor_id: 'backShoulder_letters_basecolor_id',
        backShoulder_letters_outlinecolor_div:'backShoulder_letters_outlinecolor_div',
        backShoulder_letters_outlinecolor: 'backShoulder_letters_outlinecolor',
        backShoulder_letters_outlinecolor_id:'backShoulder_letters_outlinecolor_id',
        backShoulder_logos: 'backShoulder_logos',
        backShoulderWaist_letters:'backShoulderWaist_letters',
        backShoulderWaist_letters_fontfamily:'backShoulderWaist_letters_fontfamily',
        backShoulderWaist_letters_fontfamily_id:'backShoulderWaist_letters_fontfamily_id',
        backShoulderWaist_letters_colors_id:'backShoulderWaist_letters_colors_id',
        backShoulderWaist_letters_basecolor_div:'backShoulderWaist_letters_basecolor_div',
        backShoulderWaist_letters_basecolor:'backShoulderWaist_letters_basecolor',
        backShoulderWaist_letters_basecolor_id:'backShoulderWaist_letters_basecolor_id',
        backShoulderWaist_letters_outlinecolor_div: 'backShoulderWaist_letters_outlinecolor_div',
        backShoulderWaist_letters_outlinecolor:'backShoulderWaist_letters_outlinecolor',
        backShoulderWaist_letters_outlinecolor_id:'backShoulderWaist_letters_outlinecolor_id',        

        user_height_id:'user_height_id',        
        user_weight_id:'user_weight_id',        
        user_size_id:'user_size_id',            
        place_div:'place_div',            
        place_id:'place_id',            
        jacketDetails:'jacketDetails',            
      })
    },
    methods: {
      checkFieldTypeName(event){
        let content = event.target.value;
        if(content){
          let type = (content==Number(content)) ? "number":"string";
          if(type === 'number' ){
            this.order.name_error = 'Please Enter Only Charecter';
            setTimeout( () => {
              this.order.name_error = null;
              this.order.name = '';
              $("#name").focus();
              return false;
            }, 1500)
          }
        }
      },
      checkFieldTypeMobile(event){
        let content = event.target.value;
        if(content){
          let type = (content==Number(content)) ? "number":"string";
          if(type === 'string' ){
            this.order.mobile_error = 'Please Enter Only Number';
            setTimeout( () => {
              this.order.mobile_error = null;
              this.order.mobile = '';
              $("#mobile").focus();
              return false;
            }, 1500)
          }
        }
      },
      isEmailValid: function() {
        let valid = (this.order.email == "")? "blank" : (this.order.reg.test(this.order.email)) ? 'success' : 'error';
        if(valid === 'error' || valid === 'blank'){
            this.order.email_error = 'Please Enter Valid email address';
            setTimeout( () => {
              this.order.email_error = null;
              this.order.email = '';
              $("#email").focus();
              return false;
            }, 1500)
        }
      },
      addOrder(){
        let data = this.order;
        if(!data.name){
          this.order.name_error = 'Please Enter Name';
          setTimeout( () => {
            this.order.name_error = null;
            this.order.name = '';
            $("#name").focus();
            return false;
          }, 1000)
          
        }else if(!data.email){
          this.order.email_error = 'Please Enter Email';
          setTimeout( () => {
            this.order.email_error = null;
            this.order.email = '';
            $("#email").focus();
            return false;
          }, 1000)
        }else if(!data.mobile){
          this.order.mobile_error = 'Please Enter Mobile';
          setTimeout( () => {
            this.order.mobile_error = null;
            this.order.mobile = '';
            $("#mobile").focus();
            return false;
          }, 1000)
          
          
        }else{
          let jacketFront = document.querySelectorAll('#'+this.curentJacket+'Front')[0].innerHTML;
          let jacketBack = document.querySelectorAll('#'+this.curentJacket+'Back')[0].innerHTML;
          let jacketLeft = document.querySelectorAll('#'+this.curentJacket+'Left')[0].innerHTML;
          let jacketRight = document.querySelectorAll('#'+this.curentJacket+'Right')[0].innerHTML;
          // console.log(jacketFront);
          let name = data.name;
          let mobile = data.mobile;
          let email = data.email;
          let message = data.message;
          let jacketDetails = this.jacketDetails;
          jacketDetails.name = name;
          jacketDetails.email = email;
          jacketDetails.mobile = mobile;
          jacketDetails.message = message;
          jacketDetails.jacketFront = jacketFront;
          jacketDetails.jacketBack = jacketBack;
          jacketDetails.jacketLeft = jacketLeft;
          jacketDetails.jacketRight = jacketRight;
          let user_key = this.$route.params.user_key;
          if(user_key === undefined){
            user_key = sessionStorage.getItem('user_key');  
          }else{
            user_key = this.$route.params.user_key;
          }
          jacketDetails.user_key = user_key;

          this.$store.dispatch('placeOrder', jacketDetails).then( response => {
            // this.$router.push('jacket/preview/'+response)
            this.$fire({
            title: "success",
            text: "Your order have been placed successfully. check your email for deign preview",
            type: "success",
            timer: 3000
          }).then(r => {
            window.location.href = '/';
            // $("#"+s+'_vprice_'+i).val('0.00');
          });
            sessionStorage.removeItem('user_key')
            sessionStorage.removeItem('vue-session-key')
          });
        }
        
      },
      setText(type,event){
        let content = this.leftLetter = (event.target.value).toUpperCase();
        let payload = { type: type, content: content };
        
        this.$store.dispatch('setLeftChestLetter', payload).then( response => {
            
            if(type == 'backShoulderWaist'){
                $('.'+this.backShoulder_id).css({
                  'display': 'block'
                });
            }
            if(type == 'backShoulder'){
                $('.'+this.backShoulder_id).css({
                  'display': 'block'
                });
            }
            if((type == 'leftSleeve' || type == 'rightSleeve')){
                $('.'+this[type+'_id']).css({
                  'display': 'block'
                });
                $('.'+this[type+'_id']+'_holder').css({
                  'fontSize': '3em'
                });     
            }
            if(type == 'leftChest' ){
               
                  let lettersLength = (this[type+'_letters']).length;
                  if( lettersLength == 1){
                    $('.'+this[type+'_id']+'_holder').css({
                      'fontSize': '81pt'
                    });
                  }else if( lettersLength == 2){
                    $('.'+this[type+'_id']+'_holder').css({
                      'fontSize': '54pt'
                    });
                  }else if( lettersLength == 3){
                    $('.'+this[type+'_id']+'_holder').css({
                      'fontSize': '36pt'
                    });
                  }
                  $('.'+this[type+'_id']).css({
                    'display': 'block'
                  });
              
            }
            if(type == 'rightChest' && this.rightChest_id != 'rightChest_name'){
                
                let lettersLength = (this[type+'_letters']).length;
                if( lettersLength == 1){
                  $('.'+this[type+'_id']+'_holder').css({
                    'fontSize': '4.5em'
                  });
                }else if( lettersLength == 2){
                  $('.'+this[type+'_id']+'_holder').css({
                    'fontSize': '3.5em'
                  });
                }else if( lettersLength == 3){
                  $('.'+this[type+'_id']+'_holder').css({
                    'fontSize': '3em'
                  });
                }
                $('.'+this[type+'_id']).css({
                  'display': 'block'
                });
              
            }else{
                $('.rightChest_name').css({
                  'display': 'block'
                });
            }

        })
      },
      setFontFamily(type, event){
        console.log(type);
        let fontFamily = this.fontFamily = (event.target.value);
        let fontFamilyId = this.fontFamily = (event.target.selectedIndex);
        let payload = { type: type, fontFamily: fontFamily,fontFamilyId:fontFamilyId };
        this.$store.dispatch('setLeftChestLetterFontFamily', payload).then( response => {
            if(type == 'backShoulder'){
              $('.'+this.backShoulder_id).css({
                'fontFamily': this[type+'_letters_fontfamily']
              });
            }else if(type == 'backShoulderWaist'){
              $('.'+this.backShoulder_id).css({
                'fontFamily': this[type+'_letters_fontfamily']
              });
            }else{
              $('.'+this[type+'_id']+'_holder').css({
                'fontFamily': this[type+'_letters_fontfamily']
              });
            }
        })
      },
      openCustizeColor(type, event){
        let options = event.target.options;
        let ids = [];
        options.forEach( (index, value) => {
          let values = $(options[value]).val();
          if( values != ''){
            ids.push(values)
          }
        });
        let divname = event.target.value;
        let opt_id = event.target.options.selectedIndex;
        let payload = { type: type, value: divname, ids: ids,opt_id:opt_id };
        this.$store.dispatch('setCustomizeDiv', payload);
      },
      fillCustomizeColor(type,color_type, id, color){
        let payload = {type:type, color_type: color_type,color: color,id:id};
        this.$store.dispatch('fillCustomizeColor', payload).then( response => {
            // console.log(type,color_type, id, color)
            if(type == 'backShoulderWaist_letters'){
                if(color_type === 'basecolor' ){
                  $(".backShoulderWaist_letters").css({
                    'fill': color
                  })
                }else{
                  $(".backShoulderWaist_letters").css({
                    'stroke': color
                  })
                }
            }else if(type === 'backShoulder_letters' ){
                if(color_type === 'basecolor' ){
                  $(".backShoulder_letters").css({
                    'fill': color
                  })
                }else{
                  $(".backShoulder_letters").css({
                    'stroke': color
                  })
                }
            }else if((type == 'leftSleeve' || type == 'rightSleeve')){
                if(color_type == 'basecolor'){
                  $("."+type+'_letters').css({
                    'fill': color
                  })
                }else{
                  $("."+type+'_letters').css({
                    'stroke': color
                  })
                }
            }else if(type == 'leftChest' ){
               if(color_type == 'basecolor'){
                  $("."+type+'_letters').css({
                    'fill': color
                  })
                }else{
                  $("."+type+'_letters').css({
                    'stroke': color
                  })
                }
            }else if(type == 'rightChest' && this.rightChest_id != 'rightChest_name'){
               if(color_type == 'basecolor'){
                  $("."+type+'_letters').css({
                    'fill': color
                  })
                }else{
                  $("."+type+'_letters').css({
                    'stroke': color
                  })
                }
            }else{
              $(".rightChest_name").css({
                'fill': color
              })
            }

        })
      },
      openYearColor(type, event){
        let year = event.target.value;
        let year_id = event.target.options.selectedIndex;
        let payload = { type: type, value: year,year_id:year_id };
        console.log(" year " + payload.value);
        console.log(" yearid " + payload.year_id);
        this.$store.dispatch('setYeareDiv', payload).then(response => {
            $('.'+this[type+'_id']).css({
              'display': 'block'
            });
        }) 
      },
      fillYearColor(type,color_type, id, color){
        let payload = {type:type, color_type: color_type,color: color,id:id};
        this.$store.dispatch('fillYearColor', payload).then( response => {
          if(color_type == 'basecolor'){
            $("."+type).css({
              'fill': color
            })
          }else{
            $("."+type).css({
              'stroke': color
            })
          }
        })
      },
      setImage(type,event){
        console.log(event);
        let logo = event.target.src;
        let payload = { type: type, logo: logo };
        this.$store.dispatch('setLeftChestLogo', payload).then( response => {
          $('.'+type+'_logos').css({
               'display': 'block',
               'width' : '80px' 
          });
        })
      },
      openCustomization(id,name){
        let payload = { id: id, name: name};
        this.$store.dispatch('openCustomDiv',payload)
      },
      getmenuList(){
        let x = document.querySelectorAll("#sideMenuDiv");
        let xChild = $(x[0].innerHTML);
        let attId = $(xChild).attr('id');
        let sidemenu = [];
        xChild.each((index, value) =>{
          sidemenu.push($(value).attr('id'))
        });
        return sidemenu;
      },
      yearList(){
        let selectYear = new Date().getFullYear();
        let start_year = selectYear + 10;
        let endYear = selectYear - 10;
        var years = [];
        for (var i = start_year; i > endYear; i--) {
          years.push(i)
        }
        return years;
      },
      getHeights(){
        let min_size = 137;
        let max_size = 213;
        let min_size_s;
        let max_size_l;
        var c = 0;
        var heights = [];
        for(let i = min_size; i <= max_size; i += 5 ) {
          if(c > 0){
            min_size_s = i-5;
            max_size_l = i;
            heights.push(min_size_s+'cm - ' + max_size_l + 'cm');
          }
          c++;
        }
        return heights;
        // console.log("sizes", sizes);
      },
      getWeight(){
        let min_weight = 36;
        let max_weight = 182;
        let min_weight_s;
        let max_weight_l;
        var c = 0;
        var weights = [];
        for(let i = min_weight; i <= max_weight; i += 5 ) {
          if(c > 0){
            min_weight_s = i-5;
            max_weight_l = i;
            weights.push(min_weight_s+'kg - ' + max_weight_l + 'kg');
          }
          c++;
        }
        return weights;
        // console.log('weight ' , weights);
      },
      
      chooseStyle(type, id){
        if(id == 1){
          $("#"+id).addClass('active');
          $("#2").removeClass('active');
        }else{
          $("#"+id).addClass('active');
          $("#1").removeClass('active');
        }
        let jacketStyle = this.styles;
        let payload = { style: type, jacketType: jacketStyle};
        this.$store.dispatch('set_jacket',payload);
        let sides = this.sides;
        let payload_set_front = { style: type, jacketType: jacketStyle, set: 'front', sides: sides};
        this.$store.dispatch('set_front', payload_set_front);
        if(this.jacketSelectd === true){
          this.openMenu('jacket')
        }
      },
      fillColor(type, id, color){
        $("."+type+'-list-color').removeClass('color_active');
        $("#"+type+'_'+id).addClass('color_active');
        $("."+type).css({'fill': color});
        this.$store.dispatch('designSelected', type);
        this.$store.dispatch('setColorId', {type: type, id: id,color: color})
      },
      fillColorknit(type, id, color){
        $("."+type+'-list-color').removeClass('color_active');
        $("#"+type+'_'+id).addClass('color_active');
        if(type === 'single_stripe'){
          $(".single_stripe").css({
            'opacity': 1
          });
          $(".double_stripe").css({
            'opacity': 0
          });
          $("."+type).css({'fill': color})
        }else if(type === 'double_stripe'){
          $(".single_stripe").css({
            'opacity': 0
          });
          $(".double_stripe").css({
            'opacity': 1
          });
          $("."+type).css({'fill': color})
        }else if(type === 'feather_stripe'){
          $(".single_stripe").css({
            'opacity': 0
          });
          $(".double_stripe").css({
            'opacity': 1
          });
          $(".double_stripe").css({'strokeWidth': '1.5px', 'stroke': color,'strokeOpacity': '0.75'})
        }else{
          $("."+type).css({'fill': color})
        }
        
        // this.$store.dispatch('designSelected', type)
        this.$store.dispatch('setColorId', {type: type, id: id,color: color})
      },
      
      openMenu(type){
        if(this.jacketSelectd){
          let jacket = this.curentJacket;
          let jacketStyle = this.styles;
          let sides = this.sides;
          
          let sidemenu = this.getmenuList();
          let payload = { menu : type, menuList: sidemenu };
          this.$store.dispatch('openMenu',payload);
          if(type === 'leftSleeve'){
            let payload_leftSleeve = { style: jacket, jacketType: jacketStyle, set: 'left', sides: sides};
            this.$store.dispatch('set_left', payload_leftSleeve)
          }else if(type === 'rightSleeve'){
            let payload_rightSleeve = { style: jacket, jacketType: jacketStyle, set: 'right', sides: sides};
            this.$store.dispatch('set_right', payload_rightSleeve)
          }else if(type === 'back'){
            let payload_rightSleeve = { style: jacket, jacketType: jacketStyle, set: 'back', sides: sides};
            this.$store.dispatch('set_back', payload_rightSleeve)
          }else{
            let payload_body = { style: jacket, jacketType: jacketStyle, set: 'front', sides: sides};
            this.$store.dispatch('set_front', payload_body)
          }
          // 
        }else{
          let errorMessage = "Please select jacket style";
          this.$store.dispatch('errorMessage',errorMessage)
        }
      },
      openTrim(payload){
        if(payload === 'solid'){
          $(".single_stripe,.double_stripe").css({
            'opacity': 0
          });
        }else if(payload === 'single_stripe'){
          $(".double_stripe").css({
              'opacity': 0
          });
          $(".single_stripe").css({
            'opacity': 1
          });
        }else if(payload === 'double_stripe'){
          $(".single_stripe").css({
            'opacity': 0
          });
          $(".double_stripe").css({
              'opacity': 1
          });
        }else if(payload === 'feather_stripe'){
          $(".single_stripe").css({
            'opacity': 0
          });
          $(".double_stripe").css({
              'opacity': 1
          });
        }
        this.$store.dispatch('openTrim', payload)
      }
    },
}
</script>

<style>
b, strong{ font-weight: 600}
.fa{
  line-height: 1.4 !important; padding-right: 10px;
}
.side{
  box-shadow: 2px 2px solid rgba(0,0,0,1);
  border: 1px solid rgba(0,0,0,0.1);
  padding: 5px;  
}
.panel{
  margin-bottom: 5px;
}
.jacketDesign{
  padding: 5px;
}
.jacketDesign:hover{
  background: #f1f1f1;
  opacity: 1;
  transition: opacity 0.30s ease;
}
.list-item-color{
  width: 30px;
  height:30px;
  float: left;
  display: inline-flex;
  border-radius:50%;
  margin: 5px;
  position: relative;
  box-shadow:1px 1px 1px solid rgba(0,0,0,0.5);
  border: 1px solid #ddd!important;
}
.active{
  background: #f1f1f1;
}
.error{
  background: transparent;
  color: red;
  border: 1px solid red;
  padding: 3px 15px;
}
.color_active::after{
    width: 100%;
    height: 100%;
    font-size: 9px;
    font-family: "Font Awesome 5 Free"; font-weight: 900; content: "\f00c";
    display: block;
    color: #fff;
    position: absolute;
    top: 30%;
    left: 35%;
    text-shadow: 1px 0px 0px rgba(0,0,0);
}
p.trim_btn {
    background: #f1f1f1;
    padding: 3px 10px;
    border-radius: 5px;
    font-size: 1em;
    height: 29px;
}
p.trim_btn:hover {
    background: #ddd;
}
p.active_trim{
  background: #d8d8d8;
  color: #000;
  font-weight: bold;
}
p.trim_btn > span {
  margin-left: 3px;
}
label{
  font-weight: 500;
  font-size: 14px;
}
/* custom radio */
[type="radio"]:checked,
[type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label
{
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #000;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #ddd;
    border-radius: 100%;
    background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
    content: '';
    width: 10px;
    height: 10px;
    background: #b82a2f;
    position: absolute;
    top: 4px;
    left: 4px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
}
[type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}

.form-control{
  border-radius:0px;
  margin: 5px 0;
  box-shadow: none;
}
.customList{
  padding: 6px 0 0px 5;
  border-radius: 5px;
  height: 29px;
  margin-bottom: 5px;
}
.activeList{
  background: #ececec;
  padding: 6px 0 0px 5;
  border-radius: 5px;
  height: 29px;
  margin-bottom: 5px;
  font-weight:bold;
}
.activeLevel{
  font-weight: 600;
}
.activeDiv{
  padding: 10px 5px 0px 0px;
  margin: 10px 5px 0px 0px;
}
.btn-success{
  background: #b91a1fc2;
  border: none;
  transition: all 1.8ms ease;  
}
.btn-success:active,.btn-success:hover,.btn-success:focus{
  background: #b82a2f;
}
</style>